import { IComment, ICommentContent } from "interfaces/comment";
import { useWriteComment } from "hooks/comments/useWriteComment";

interface Result {
  createEventComment: (content: ICommentContent) => Promise<IComment>;
  updateEventComment: (
    commentId: number,
    content: ICommentContent
  ) => Promise<IComment>;
  deleteEventComment: (commentId: number) => Promise<void>;
}

export function useWriteEventComment(
  eventId: number,
  onCommentsChanged: () => void
): Result {
  const { createComment, updateComment, deleteComment } = useWriteComment(
    `events/${eventId}`,
    onCommentsChanged
  );

  return {
    createEventComment: createComment,
    updateEventComment: updateComment,
    deleteEventComment: deleteComment
  };
}
